import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiResponse } from '@custom/Utils/constants/interfaces';
import { _moveExtra } from '@custom/Utils/constants/apiUrls';

const moveToExtraStorage = createAsyncThunk(
  'moveToExtraStorage',
  async (value: any, { rejectWithValue }) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');

    try {
      const response = await fetch(_moveExtra.moveToExtraStorage, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(value),
      });

      const data: ApiResponse<any> = await response.json(); // ✅ Only one read

      if (response.ok) {
        return data; // ✅ success
      } else {
        return rejectWithValue(data); // ✅ handle error
      }
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Unexpected error occurred');
    }
  }
);

export default moveToExtraStorage;
